<template>
  <div class="fs">
    <div class="w clearfix">
      <div class="banner">
        <swiper v-if="bannerList.length" :options="swiperOption" class="banner-Swiper">
          <swiper-slide
            v-for="item in bannerList"
            :key="item.id"
            :style="{backgroundColor:item.color}"
          >
            <router-link :to="item.url==null ? '' : item.url">
              <img :src="item.image" />
            </router-link>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>-->
        </swiper>
      </div>
      <div class="aside_right">
        <div v-if="!flag" class="aside_header">
          <div class="avatar">
            <img src="../../assets/index/banner_icon/avatar.png" />
          </div>
          <div class="message">
            <p>Hi! 您还未登录</p>
          </div>
          <div class="login_method">
            <div class="first">
              <i></i>
              <a href="javascript:;" @click="goLogin()">登陆</a>
            </div>
            <span>|</span>
            <div class="two">
              <i></i>
              <a href="javascript:;" @click="goregister()">注册</a>
            </div>
          </div>
        </div>
        <div v-else class="aside_header as1">
          <div class="avatar">
            <router-link to="/userinfo">
              <img style="width:80px;cursor:pointer" :src="userInfo.avatar" />
            </router-link>
          </div>
          <div class="message">
            <p>
              <router-link to="/userinfo">用户名:&nbsp;&nbsp;{{userInfo.nickname}}</router-link>
            </p>
            <p>
              <router-link to="/userinfo">手 机:&nbsp;&nbsp;{{userInfo.mobile}}</router-link>
            </p>
          </div>
          <div class="login_method">
            <div class="first">
              <i></i>
              <router-link to="/userinfo">设置</router-link>
            </div>
            <span>|</span>
            <div class="two">
              <i></i>
              <a href="javascript:;" @click="exit()">退出</a>
            </div>
          </div>
          <div class="dingdan">
            <ul class="clearfix">
              <li>
                <a href="javascript:void(0);" @click="goOrder(8)">
                  <span>待收货</span>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" @click="goOrder(3)">
                  <span>待收货</span>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" @click="goOrder(4)">
                  <span>待评价</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="aside_fotter">
          <router-link to="/order">
            <img src="../../assets/index/banner_icon/dingdan.png" />
            <p>我的订单</p>
          </router-link>
          <router-link to="/order">
            <img src="../../assets/index/banner_icon/shoucang.png" />
            <p>我的收藏</p>
          </router-link>
          <router-link to="/order">
            <img src="../../assets/index/banner_icon/youhui.png" />
            <p>优惠券</p>
          </router-link>
          <router-link to="/batchorder">
            <img src="../../assets/index/banner_icon/piliang.png" />
            <p>批量下单</p>
          </router-link>
          <router-link to="/address">
            <img src="../../assets/index/banner_icon/dizhi.png" />
            <p>地址管理</p>
          </router-link>
          <router-link to="/reportform">
            <img src="../../assets/index/banner_icon/yue.png" />
            <p>余额流水</p>
          </router-link>
          <router-link to="/userinfo">
            <img src="../../assets/index/banner_icon/geren.png" />
            <p>个人中心</p>
          </router-link>
          <router-link to="/order">
            <img src="../../assets/index/banner_icon/yunpan.png" />
            <p>我的云盘</p>
          </router-link>
          <router-link to="/backshouye">
            <img src="../../assets/index/banner_icon/zhanghu.png" />
            <p>我的账户</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  name: 'carrousel',
  data() {
    return {
      flag: false,
      swiperOption: {
        spaceBetween: 30,
        effect: 'fade',
        speed: 1000,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      userInfo: {},
      bannerList: []
    }
  },
  created() {
    this.queryBannerList()
    const bool = window.localStorage.getItem('token')
    const userInfo = JSON.parse(window.localStorage.getItem('u'))
    if (!bool) {
      return (this.flag = false)
    }
    this.flag = true
    this.userInfo = userInfo
  },
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    goregister() {
      this.$router.push('/register')
    },
    goDetail() {
      this.$router.push('/detail')
    },
    exit() {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('u')
      this.$router.push('/login')
    },
    async queryBannerList() {
      const { data: res } = await this.$http.get('api/index/getbanner')
      this.bannerList = res.data
    },
    goOrder(status = 0) {
      window.sessionStorage.setItem('status', status)
      this.$router.push('/order')
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="less" scoped>
.fs {
  position: relative;
  height: 470px;
  transition: all 0.5s;
  .w {
    height: 470px;
    display: flex;
    justify-content: flex-end;
    .banner {
      width: 782px;
      height: 470px;
      float: right;
      .banner-Swiper {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 470px;
      }
      .swiper-slide {
        height: 100%;
        text-align: center;
        font-size: 18px;
        a {
          position: relative;
          display: block;
          width: 782px;
          height: 470px;
          margin: 0 auto;
          transform: translate(-9px, 0px);
        }
        img {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 782px;
          height: 470px;
          max-width: 100%;
          max-height: 100%;
          margin-left: 50px;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }
      }
      .swi-one {
        background: #cebeb6;
      }
      .swi-two {
        background: #ffffff;
      }
      .swi-three {
        background: #e6e9ee;
      }
      .swi-four {
        background: #6f3c1e;
      }
      .swi-five {
        background: #6796e1;
      }
      .swi-six {
        background: #f7cf3d;
      }
      .swiper-button-prev {
        left: 29%;
      }
      .swiper-button-next {
        right: 30%;
      }
    }
    .aside_right {
      position: relative;
      border-top: 2px solid #a77c5a;
      width: 218px;
      height: 424px;
      background-color: #fff;
      float: right;
      padding: 22px 0;
      z-index: 999;
      .aside_header {
        width: 218px;
        height: 240px;
        text-align: center;
      }
      .message {
        margin: 13px 0;
      }
      .login_method {
        display: flex;
        span {
          margin: 0 8px;
        }
        .first {
          display: flex;
          align-items: center;
          margin-left: 60px;
          i {
            width: 15px;
            height: 14px;
            background: url('../../assets/index/banner_icon/login.png');
            margin-right: 2px;
          }
        }
        .two {
          display: flex;
          align-items: center;
          i {
            width: 15px;
            height: 14px;
            background: url('../../assets/index/banner_icon/register.png');
            margin-right: 2px;
          }
        }
      }
      .as1 {
        .login_method {
          display: flex;
          span {
            margin: 0 8px;
          }
          .first {
            display: flex;
            align-items: center;
            margin-left: 60px;
            i {
              width: 15px;
              height: 14px;
              background: url('../../assets/index/banner_icon/setting.png');
              margin-right: 2px;
            }
          }
          .two {
            display: flex;
            align-items: center;
            i {
              width: 15px;
              height: 14px;
              background: url('../../assets/index/banner_icon/exit.png')
                no-repeat;
              margin-right: 2px;
            }
          }
        }
        .dingdan {
          margin-top: 30px;
          ul {
            li {
              float: left;
              width: 62px;
              height: 35px;
              display: flex;
              margin-left: 10px;
              a {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                flex-direction: column;
                i {
                  color: #e83030;
                }
              }
            }
          }
        }
      }
      .aside_hot {
        box-sizing: border-box;
        height: 70px;
        border: 1px solid #f3f4f5;
        padding: 16px 10px;
        p {
          color: #666;
          font-size: 12px;
          margin-bottom: 10px;
          span {
            color: #e83030;
            font-weight: bold;
            margin-right: 2px;
          }
        }
      }
      .aside_fotter {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        padding: 20px;
        a {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 33%;
          margin-bottom: 5px;
          p {
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>
